import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { SecureStorage } from './secure-storage';

@Injectable({
  providedIn: 'root'
})
export class GlobalService {
  private currentUserSubject: BehaviorSubject<any>;
  public currentUser: Observable<any>;
  customerDefaultLanguage:string=null;
  constructor(
    private secureStorage: SecureStorage,
  ) {
    this.currentUserSubject = new BehaviorSubject<any>(this.secureStorage.getKeyData('repairInfo'));
    this.currentUser = this.currentUserSubject.asObservable();
  }

  setAppInitialData(info: any) {
    const tinyInfo = {
      CustomerId: info.customerId,
      VehicleId: info.vehicleId,
      RepairId: info.repairId,
      DealerId: info.dealerId,
      CustomerEmailId: info.customerEmailId,
      AppointmentGuid: info.appointmentGuid,
      IsActiveAppointment: info.isActiveAppointment
  };

    // remove if already exist
    this.secureStorage.removeKey('repairInfo');

    this.secureStorage.setKeyData('repairInfo', tinyInfo);
    this.currentUserSubject.next(tinyInfo);

    // theme info
    let single = Object();
    single.code = 'sytnerTheme';
    

    // remove if already exist
    this.secureStorage.removeKey('cTheme');
    this.secureStorage.setKeyData('cTheme', single);

  }

  public get getAppInitialData(): any {
    return this.currentUserSubject.value;
  }

  getOrderStatus(statusCode: number) {

    let orderStatus = [
      {
        code: 0,
        text: ''
      },
      {
        code: 1,
        text: 'lblArrivedForDrop'
      },
      {
        code: 2,
        text: 'lblInProgress'
      },
      {
        code: 3,
        text: 'lblOnBridge'
      },
      {
        code: 4,
        text: 'lblReadyToDeliver'
      },
      {
        code: 5,
        text: 'lblPaymentConfirmed'
      },
      {
        code: 6,
        text: 'lblComplete'
      }
    ];

    return orderStatus.find(x => x.code === statusCode);
  }

  getBrandLogo(key: any) {
    let logos = [
      {
        name: 'MER',
        path: 'assets/images/brandlogo/mercedes.svg',
        pngPath: 'assets/images/brandlogo/mercedes.png'
      },
      {
        name: 'MA',
        path: 'assets/images/brandlogo/mazda.svg',
        pngPath: 'assets/images/brandlogo/mazda.png'
      },
      {
        name: 'AUD',
        path: 'assets/images/brandlogo/audi.svg',
        pngPath: 'assets/images/brandlogo/audi.png'
      },
      {
        name: 'CHE',
        path: 'assets/images/brandlogo/chevrolet.svg',
        pngPath: 'assets/images/brandlogo/chevrolet.png'
      },
      {
        name: 'HON',
        path: 'assets/images/brandlogo/honda.svg',
        pngPath: 'assets/images/brandlogo/honda.png'
      },
      {
        name: 'FIA',
        path: 'assets/images/brandlogo/fiat.svg',
        pngPath: 'assets/images/brandlogo/fiat.png'
      },
      {
        name: 'FOR',
        path: 'assets/images/brandlogo/ford.svg',
        pngPath: 'assets/images/brandlogo/ford.png'
      },
      {
        name: 'HYU',
        path: 'assets/images/brandlogo/hyundai.svg',
        pngPath: 'assets/images/brandlogo/hyundai.png'
      },
      {
        name: 'VO',
        path: 'assets/images/brandlogo/volvo.svg',
        pngPath: 'assets/images/brandlogo/volvo.png'
      },
      {
        name: 'LNR',
        path: 'assets/images/brandlogo/land-rover.svg',
        pngPath: 'assets/images/brandlogo/land-rover.png'
      },
      {
        name: 'KIA',
        path: 'assets/images/brandlogo/kiamotor.svg',
        pngPath: 'assets/images/brandlogo/kiamotor.png'
      },
      {
        name: 'BMW',
        path: 'assets/images/brandlogo/bmw.svg',
        pngPath: 'assets/images/brandlogo/bmw.png'
      },
      {
        name: 'VW',
        path: 'assets/images/brandlogo/volkswagen.svg',
        pngPath: 'assets/images/brandlogo/volkswagen.png'
      },
      {
        name: 'FO',
        path: 'assets/images/brandlogo/ford.svg',
        pngPath: 'assets/images/brandlogo/ford.png'
      },
      {
        name: 'MAZ',
        path: 'assets/images/brandlogo/mazda.svg',
        pngPath: 'assets/images/brandlogo/mazda.png'
      },
      {
        name: 'PEU',
        path: 'assets/images/brandlogo/peugeot.svg',
        pngPath: 'assets/images/brandlogo/peugeot.png'
      },
      {
        name: 'PE',
        path: 'assets/images/brandlogo/peugeot.svg',
        pngPath: 'assets/images/brandlogo/peugeot-logo.png'
      },
      {
        name: 'CIT',
        path: 'assets/images/brandlogo/citroen.svg',
        pngPath: 'assets/images/brandlogo/citroen.png'
      },
      {
        name: 'CI',
        path: 'assets/images/brandlogo/citroen.svg',
        pngPath: 'assets/images/brandlogo/citroen.png'
      },
      {
        name: 'DS',
        path: 'assets/images/brandlogo/ds.svg',
        pngPath: 'assets/images/brandlogo/ds.png'
      },
      {
        name: 'MIN',
        path: 'assets/images/brandlogo/mini.svg',
        pngPath: 'assets/images/brandlogo/mini.png'
      },
      {
        name: 'MIT',
        path: 'assets/images/brandlogo/mitsubishi.svg',
        pngPath: 'assets/images/brandlogo/mitsubishi.png'
      },
      {
        name: 'NIS',
        path: 'assets/images/brandlogo/nissan.svg',
        pngPath: 'assets/images/brandlogo/nissan.png'
      },
      {
        name: 'OPE',
        path: 'assets/images/brandlogo/opel.svg',
        pngPath: 'assets/images/brandlogo/opel.png'
      },
      {
        name: 'REN',
        path: 'assets/images/brandlogo/renault.svg',
        pngPath: 'assets/images/brandlogo/renault.png'
      },
      {
        name: 'SKO',
        path: 'assets/images/brandlogo/skoda.svg',
        pngPath: 'assets/images/brandlogo/skoda.png'
      },
      {
        name: 'SUB',
        path: 'assets/images/brandlogo/subaru.svg',
        pngPath: 'assets/images/brandlogo/subaru.png'
      },
      {
        name: 'SUZ',
        path: 'assets/images/brandlogo/suzuki.svg',
        pngPath: 'assets/images/brandlogo/suzuki.png'
      },
      {
        name: 'TES',
        path: 'assets/images/brandlogo/tesla.svg',
        pngPath: 'assets/images/brandlogo/tesla.png'
      },
      {
        name: 'TOY',
        path: 'assets/images/brandlogo/toyota.svg',
        pngPath: 'assets/images/brandlogo/toyota.png'
      },
      {
        name: 'DIA',
        path: 'assets/images/brandlogo/daihatsu.svg',
        pngPath: 'assets/images/brandlogo/daihatsu.png'
      },
      {
        name: 'VOL',
        path: 'assets/images/brandlogo/volvo.svg',
        pngPath: 'assets/images/brandlogo/volvo.png'
      },
      {
        name: 'SMA',
        path: 'assets/images/brandlogo/smart.svg',
        pngPath: 'assets/images/brandlogo/smart.png'
      },
      {
        name: 'SET',
        path: 'assets/images/brandlogo/SETRA.svg',
        pngPath: 'assets/images/brandlogo/SETRA.png'
      },
      {
        name: 'FUS',
        path: 'assets/images/brandlogo/fuso.svg',
        pngPath: 'assets/images/brandlogo/fuso.png'
      },
      {
        name: 'MBV',
        path: 'assets/images/brandlogo/mercedes.svg',
        pngPath: 'assets/images/brandlogo/mercedes.png'
      }
    ]

    return logos.find(x => x.name.toLowerCase() === key.toLowerCase());
    
  }

}
